// @flow
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';

import rootReducer from './reducers/index';
import createStore from './stores/index';
import initialState from './stores/initial';
import App from './App';
import * as serviceWorker from './serviceWorker';

import './index.css';

const store = createStore(initialState, rootReducer);

const root = document.getElementById('root');

if (root !== null) {
  ReactDOM.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>,
    root
  );
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
